/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_Signin_To_FavoriteInputs */

const en_please_signin_to_favorite = /** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please sign in to save items to your favorites`)
};

const es_please_signin_to_favorite = /** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, inicia sesión para guardar artículos en tus favoritos`)
};

const fr_please_signin_to_favorite = /** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vous connecter pour enregistrer des articles dans vos favoris`)
};

const de_please_signin_to_favorite = /** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte melde dich an, um Artikel in deinen Favoriten zu speichern`)
};

const id_please_signin_to_favorite = /** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan masuk untuk menyimpan item ke favorit Anda`)
};

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const ja_please_signin_to_favorite = en_please_signin_to_favorite;

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const zh_please_signin_to_favorite = en_please_signin_to_favorite;

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const ar_please_signin_to_favorite = en_please_signin_to_favorite;

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const it_please_signin_to_favorite = en_please_signin_to_favorite;

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const ru_please_signin_to_favorite = en_please_signin_to_favorite;

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const pt_please_signin_to_favorite = en_please_signin_to_favorite;

/** @type {(inputs: Please_Signin_To_FavoriteInputs) => LocalizedString} */
const ko_please_signin_to_favorite = en_please_signin_to_favorite;

/**
* | output |
* | --- |
* | "Please sign in to save items to your favorites" |
*
* @param {Please_Signin_To_FavoriteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const please_signin_to_favorite = /** @type {((inputs?: Please_Signin_To_FavoriteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_Signin_To_FavoriteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_please_signin_to_favorite(inputs)
	if (locale === "es") return es_please_signin_to_favorite(inputs)
	if (locale === "fr") return fr_please_signin_to_favorite(inputs)
	if (locale === "de") return de_please_signin_to_favorite(inputs)
	if (locale === "ja") return ja_please_signin_to_favorite(inputs)
	if (locale === "zh") return zh_please_signin_to_favorite(inputs)
	if (locale === "ar") return ar_please_signin_to_favorite(inputs)
	if (locale === "id") return id_please_signin_to_favorite(inputs)
	if (locale === "it") return it_please_signin_to_favorite(inputs)
	if (locale === "ru") return ru_please_signin_to_favorite(inputs)
	if (locale === "pt") return pt_please_signin_to_favorite(inputs)
	return ko_please_signin_to_favorite(inputs)
});